import { render, staticRenderFns } from "./ReleaseSteps.vue?vue&type=template&id=38c62bb3&scoped=true"
import script from "./ReleaseSteps.vue?vue&type=script&lang=ts"
export * from "./ReleaseSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c62bb3",
  null
  
)

export default component.exports